import axios from 'axios'

export default {
    async fetch() {
        return await axios.get(`company`)
    },
    async update(model) {
        return await axios.put(`company`, model)
    },

    async fetchConfiguration(key) {
        return await axios.get(`company/configurations/${key}`)
    },

    async updateConfiguration({ key, text_value, bool_value }) {
        return await axios.post(`company/configurations`, {
            key,
            text_value,
            bool_value,
        })
    },

    async deleteConfiguration(key) {
        return await axios.delete(`company/configurations`, key)
    },
}
